export default __webpack_public_path__ + "static/media/openSourcee.8eb7ec00.png";